export enum enumPasswordLabel {
  COUNT,
  UPPER_LETTER,
  LOWER_LETTER,
  INC_NUMBER,
}
